const createSafeStringifyReplacer = () => {
  const seen = new WeakSet();
  const replacer = (_key: string, value: any) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return '[Circular]';
      }
      seen.add(value);
    }
    return value;
  };
  return replacer;
};

const safeStringify = (value: any, space?: string | number): string | void => {
  try {
    return JSON.stringify(value, createSafeStringifyReplacer(), space);
  } catch (e) {
    return undefined;
  }
};

export default safeStringify;
